<template>
	<div class="data-picker-container">
		<div v-if="lableText.length !== 0" :class="disabled ? 'lable-text-disable':'lable-text'">{{ lableText }}</div>
		<v-menu
			v-if="$vuetify.breakpoint.width < 500"
			v-model="menu"
			:close-on-content-click="false"
			:disabled="disabled"
			offset-y
			min-width="auto"
		>
			<template v-slot:activator="{ on, attrs }">
				<v-text-field
					:id="refId"
					:ref="`input-${refId}`"
					v-bind="attrs"
					v-on="on"
					:value="formatDate(date)"
					:color="color"
					:background-color="background"
					transition="scale-transition"
					:outlined="isOutlined"
					:hide-details="!persistentHint"
					:persistent-hint="persistentHint"
					:clearable="isClear"
					:hint="suggestionText"
					:error="error_messages.length !== 0 || error"
					:messages="error_messages"
					dense
					readonly
					:disabled="disabled"
					@click:clear="onDateClear()"
					@change="onDateChange($event)"
					@keydown="onKeydown($event)"
					@input="onDateInput($event)"
				>
					<template v-if="isIcon" v-slot:prepend-inner>
						<div v-bind="attrs" v-on="on">
							<Calendar color="rgba(25, 42, 62, 0.5)" width="20" height="20" style="margin-top: 2px"/> 				
						</div>
					</template>
				</v-text-field>
			</template>
			<v-date-picker
				v-model="date"
				:color="color"
				:disabled="disabled"
				:allowed-dates="allowedDates"
				no-title
				@input="onDatePicker()"
				@change="setColor"
				@update:picker-date="setColor"
			></v-date-picker>
		</v-menu>
		<v-text-field
			v-if="$vuetify.breakpoint.width >= 500"
			:id="refId"
			:ref="`input-${refId}`"
			:value="formatDate(date)"
			:color="color"
			:background-color="background"
			transition="scale-transition"
			:outlined="isOutlined"
			:placeholder="placeholder"
			dense
			:hide-details="!persistentHint"
			:persistent-hint="persistentHint"
			:clearable="isClear"
			:hint="suggestionText"
			:error="error_messages.length !== 0 || error"
			:messages="error_messages"
			:disabled="disabled"
			@click:clear="onDateClear()"
			@change="onDateChange($event)"
			@keydown="onKeydown($event)"
			@input="onDateInput($event)"
		>
			<template v-if="isIcon" v-slot:prepend-inner>
				<v-menu
					v-model="menu"
					:close-on-content-click="false"
					:disabled="disabled"
					offset-y
					:nudge-left="nudgeLeft"
					min-width="auto"
				>
					<template v-slot:activator="{ on, attrs }">
						<div v-bind="attrs" v-on="on">
							<Calendar color="rgba(25, 42, 62, 0.5)" width="20" height="20" style="margin-top: 2px"/> 
						</div>
					</template>
					<v-date-picker
						v-model="date"
						:color="color"
						:disabled="disabled"
						:allowed-dates="allowedDates"
						no-title
						@input="onDatePicker()"
						@change="setColor"
						@update:picker-date="setColor"
					></v-date-picker>
				</v-menu>
			</template>
		</v-text-field>
	</div>
</template>
<script>
import Calendar from "@/components/icons/calendar.vue";
import moment from 'moment';
import config from "@/config.js";

/** 31 days for a month, (0?[1-9]|[12]\d|3[01])-(0?[13578]|1[02])-((19|20)\d{2}) */
/** 30 days for a month, (0?[1-9]|[12]\d|30)-(0?[469]|11)-((19|20)\d{2}) */
/** 28 days for a month, (0?[1-9]|1\d|2[0-8])-0?2-((19|20)\d{2}) */
/** 29 days for a month, (0?[1-9]|[12]\d)-0?2-((19|20)([13579][26]|[2468][048]|0[48])) */
/** 
const DATE_FORMAT_REG0 = /^(((0?[1-9]|[12]\d|3[01]) ((J|j)an(uary)?|(M|m)a(r(ch)?|y)|(J|j)ul(y)?|(A|a)ug(ust)?|(O|o)ct(ober)?|(D|d)ec(ember)?) ((19|20)\d{2}))|((0?[1-9]|[12]\d|30) ((A|a)pr(il)?|(J|j)un(e)?|((S|s)ept|(N|n)ov)(ember)?) ((19|20)\d{2}))|((0?[1-9]|[12]\d|30) ((F|f)eb(ruary)?) ((19|20)\d{2}))|((0?[1-9]|[12]\d|30) ((F|f)eb(ruary)?) ((19|20)([13579][26]|[2468][048]|0[48]))))$/
const DATE_FORMAT_REG1 = /^((0?[1-9]|[12]\d|3[01])\/(0?[13578]|1[02])\/((19|20)\d{2})|(0?[1-9]|[12]\d|30)\/(0?[469]|11)\/((19|20)\d{2})|(0?[1-9]|1\d|2[0-8])\/0?2\/((19|20)\d{2})|(0?[1-9]|[12]\d)\/0?2\/((19|20)([13579][26]|[2468][048]|0[48])))$/;
const DATE_FORMAT_REG2 = /^((0?[1-9]|[12]\d|3[01])\.(0?[13578]|1[02])\.((19|20)\d{2})|(0?[1-9]|[12]\d|30)\.(0?[469]|11)\.((19|20)\d{2})|(0?[1-9]|1\d|2[0-8])\.0?2\.((19|20)\d{2})|(0?[1-9]|[12]\d)\.0?2\.((19|20)([13579][26]|[2468][048]|0[48])))$/;
const DATE_FORMAT_REG3 = /^((0?[1-9]|[12]\d|3[01])|(0[1-9]|[12]\d|3[01])(0?[13578]|1[02])|(0[1-9]|[12]\d|30)(0?[469]|11)|(0[1-9]|1\d|2[0-8])(0?2)|(0[1-9]|[12]\d|3[01])(0[13578]|1[02])((19|20)?\d{2})|(0[1-9]|[12]\d|30)(0[469]|11)((19|20)?\d{2})|(0[1-9]|1\d|2[0-8])(02)((19|20)?\d{2})|(0[1-9]|[12]\d)(02)((19|20)?([13579][26]|[2468][048]|0[48])))$/;
const FORMAT = ['D', 'DD', 'DDMM','DM', 'DDMYYYY', 'DDMMYYYY', 'DD MMM YYYY', 'DD/MM/YYYY', 'DD.MM.YYYY'];
*/
export default {
	name: 'DatePicker',
	props: {
		isOutlined: {
			type: Boolean,
			default: false
		},
		isIcon: {
			type: Boolean,
			default: false
		},
		isClear: {
			type: Boolean,
			default: true
		},
		color: {
			type: String,
			default: '#109cf1'
		},
		background: {
			type: String,
			default: '#FAFAFA'
		},
		lableText: {
			type: String,
			default: ''
		},
		dateInvalid: {
			type: String,
			default: 'Invalid date'
		},
		suggestionText: {
			type: String,
			default: 'eg, 120322 or 12/3/2022 or 12.3.2022'
		},
		/**  accepts ISO 8601 date strings (YYYY-MM-DD) */
		dateInit: {
			type: String,
			default: ''
		},
		isWebsite: {
			type: Boolean,
			default: true
		},
		disabled: {
			type: Boolean,
			default: false
		},
		error: {
			type: Boolean,
			default: false
		},
		persistentHint: {
			type: Boolean,
			default: true
		},
		refId: {
			type: String,
			default: ''
		},
		validRange: {
			type: Array,
			default: () => []
		},
		validRangeTextColor: {
			type: String,
			default: ''
		},
		placeholder: {
			type: String,
			default: ''
		},
		nudgeLeft: {
			type: Number,
			default: 0
		}
	},
	data() {
		return {
			menu: false,
			date: this.dateInit.length !== 0 ? this.dateInit : null,
			error_messages: '',
			date_format: config.date_format
		}
	},
	components: {
		Calendar
	},
	watch: {
		dateInit() {
			this.date = this.dateInit && this.dateInit.length !== 0 ? this.dateInit : null;
		},
		menu(value) {
			if (value) {
				this.setColor(this.date || moment().format('YYYY-MM-DD'));
			}
		},
	},
	methods: {
		allowedDates(val) {
			if (this.validRange.length === 0) {
				return true
			} else if (this.validRange.length === 1) {
				return val >= this.validRange[0]
			} else {
				return val >= this.validRange[0] && val <= this.validRange[1]
			}
		},	
		isInValidRange(val) {
			if (this.validRange.length === 0) {
				return false;
			} else if (this.validRange.length === 1) {
				return val >= this.validRange[0];
			} else {
				return val >= this.validRange[0] && val <= this.validRange[1];
			}
		},
		setColor(val) {
			this.$nextTick(() => {
				const current_date = moment().format('YYYY-MM-DD');
				const month_text = moment(val, ['YYYY-MM', 'YYYY-MM-DDDD']).format('YYYY-MM');

				const current_element = document.getElementsByClassName('v-menu__content');
				for (let index = 0; index < current_element.length; index++) {
					const element_note = current_element[index];
					const allDates = element_note.getElementsByClassName('v-btn__content');

					if (allDates.length !== 0 ) {
						for (let index = 0; index < allDates.length; index++) {
							const date = allDates[index];
							if (date.localName === 'div') {
								const date_innerHTML = date.innerHTML.length === 1 ? `0${date.innerHTML}`: `${date.innerHTML}`;
								const date_text = `${month_text}-${date_innerHTML}`;

								if (date_text === current_date && date_text === this.date) {
									date.parentNode.style = `color: #FFFFFF !important; background-color: ${this.color} !important`;
								}
								if (date_text !== current_date && date_text === this.date) {
									date.parentNode.style = `color: #FFFFFF !important; background-color: ${this.color} !important; opacity: 0.5 !important;`;
								}
								if (date_text !== current_date && date_text !== this.date) {
									if (this.validRange.length === 0) {
										date.parentNode.style = `color: rgba(0, 0, 0, 0.87) !important;!important; opacity: 1 !important;`;
									} else {
										if (this.isInValidRange(date_text)) {
											const date_color = this.validRangeTextColor || 'rgba(0, 0, 0, 0.87)';
											date.parentNode.style = `color: ${date_color} !important;!important; opacity: 1 !important;`;
										}
									}
								}
							}
						}
					}
				}
			})
		},
		formatDate(value) {
			if(!value) return null;
			return moment(value).format('DD MMM YYYY');
		},
		onDateInput(date) {
			/** this function helps the date picker to synchronize with the date, the main logic in onDateStartChange() */
			if (!date) return;

			const isValid = moment(date, this.date_format).isValid();
			
			if (isValid && this.menu_start) {
				this.date = moment(date, this.date_format).format('YYYY-MM-DD');
			}
		},
		onDateChange(date) {
			this.error_messages = '';
			if (date) {
				const isValid = moment(date, this.date_format).isValid();

				if (isValid) {
					if (date === '31' && !moment(date, 'DD').isValid()) {
						const pre_month = moment().month() - 1;
						const pre_month_str = moment().month(pre_month).format('MM');
						const date_tmp = `${date}${pre_month_str}`;
						this.date = moment(date_tmp, 'DDMM').format('YYYY-MM-DD');
					} else {
						this.date= moment(date, this.date_format).format('YYYY-MM-DD');
					}

					this.$emit('date', this.date);
				} else {
					this.error_messages = this.dateInvalid;
					this.$emit('date', null);
				}
			} else {
				this.$emit('date', null);
			}
		},
		onDateClear() {
			this.date = null;
			this.error_messages = '';
			this.$emit('date', null);
		},
		onKeydown(e) {
			if (e.keyCode === 13) {
				this.menu = false;
			}
		},
		onDatePicker() {
			this.menu = false;
			this.error_messages = '';
			this.$emit('date', this.date);
		},
	}
}
</script>
<style lang="scss" scoped>
.data-picker-container {
  display: flex;
  flex-flow: column nowrap;
}
.lable-text {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #37495F;
  opacity: 0.87;
}
.lable-text-disable {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #B9C2CB;
  opacity: 0.87;
}
.icon-hover {
	&:hover {
		cursor: pointer;
	}
}
</style>